/**
 * This constant represent the list of icons displayed under user group creation
 * @type {[{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string},{code: string; highlighted: boolean; backgroundColor: string; color: string}]}
 */
export class IconList {
  readonly icons: {
    code: string;
    highlighted: boolean;
    backgroundColor: string;
    borderColor: string;
    color: string;
    selected: boolean;
  }[] = [
    {
      code: 'fa-building-o',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-bullhorn',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-ban',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-calculator',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-calendar-check-o',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-car',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-dollar',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-envelope',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-font-awesome',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-leaf',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-eye',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-exclamation-triangle',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-fire-extinguisher',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-cutlery',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-handshake-o',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-gavel',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-hourglass',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-key',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-map-marker',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-heart',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-lock',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-paperclip',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-bell-o',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-phone',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-pencil',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-search',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-wrench',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-star',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-suitcase',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-truck',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
    {
      code: 'fa-book',
      highlighted: true,
      backgroundColor: '#FFF',
      borderColor: '#E8EEF4',
      color: '#456287',
      selected: false,
    },
  ];
}
